// Module
var code = "<template><require from=\"../loading/loading\"></require><div class=\"button-icon ${disabled ? 'disabled':''}\" tabindex.bind=\"tab\"><i class=\"button-icon-value\" if.bind=\"!loading\">${icon}</i><loading class=\"small color-white\" if.bind=\"loading\"></loading></div></template>";
// Exports
module.exports = code;